const BrowserIcon = () => (
  <svg
    fill="none"
    height="12"
    viewBox="0 0 52 12"
    width="52"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 6a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z"
      fill="#FF5F57"
      stroke="#E14640"
    />
    <path
      d="M31.5 6a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z"
      fill="#FFBD2E"
      stroke="#DFA123"
    />
    <path
      d="M51.5 6a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z"
      fill="#28CA42"
      stroke="#1DAD2C"
    />
  </svg>
);

export default BrowserIcon;
